var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.92039 0C5.69976 0 4.50654 0.381218 3.49163 1.09545C2.47671 1.80968 1.68568 2.82484 1.21857 4.01256C0.751453 5.20028 0.629235 6.50721 0.867368 7.76809C1.1055 9.02896 1.69329 10.1872 2.5564 11.0962C3.41952 12.0052 4.51919 12.6243 5.71637 12.8751C6.91354 13.1259 8.15444 12.9972 9.28216 12.5052C10.4099 12.0132 11.3737 11.1801 12.0519 10.1112C12.73 9.04229 13.092 7.78558 13.092 6.5C13.0902 4.77667 12.4394 3.12445 11.2824 1.90586C10.1254 0.687282 8.55665 0.00186392 6.92039 0V0ZM6.92039 11.9167C5.9032 11.9167 4.90885 11.599 4.06309 11.0038C3.21732 10.4086 2.55813 9.56264 2.16887 8.57287C1.77961 7.5831 1.67776 6.49399 1.8762 5.44326C2.07465 4.39253 2.56447 3.42737 3.28373 2.66984C4.003 1.9123 4.91939 1.39642 5.91704 1.18741C6.91468 0.97841 7.94877 1.08568 8.88853 1.49565C9.82829 1.90563 10.6315 2.5999 11.1966 3.49066C11.7618 4.38143 12.0634 5.42868 12.0634 6.5C12.0619 7.93611 11.5196 9.31294 10.5554 10.3284C9.59121 11.3439 8.28394 11.9151 6.92039 11.9167Z",
    fill: "#063B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92032 5.41687H6.40602C6.26962 5.41687 6.13881 5.47394 6.04236 5.57552C5.94591 5.6771 5.89172 5.81488 5.89172 5.95854C5.89172 6.1022 5.94591 6.23997 6.04236 6.34155C6.13881 6.44314 6.26962 6.5002 6.40602 6.5002H6.92032V9.7502C6.92032 9.89386 6.97451 10.0316 7.07096 10.1332C7.16741 10.2348 7.29822 10.2919 7.43462 10.2919C7.57102 10.2919 7.70184 10.2348 7.79829 10.1332C7.89474 10.0316 7.94892 9.89386 7.94892 9.7502V6.5002C7.94892 6.21289 7.84055 5.93734 7.64765 5.73417C7.45475 5.53101 7.19312 5.41687 6.92032 5.41687Z",
    fill: "#063B9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.92038 4.33313C7.34644 4.33313 7.69183 3.96936 7.69183 3.52063C7.69183 3.0719 7.34644 2.70813 6.92038 2.70813C6.49432 2.70813 6.14893 3.0719 6.14893 3.52063C6.14893 3.96936 6.49432 4.33313 6.92038 4.33313Z",
    fill: "#063B9A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.3432,
    height: 13,
    fill: "white",
    transform: "translate(0.748779)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ad7297d474a6a19a7838825f73c1a2cd.svg";
export { ForwardRef as ReactComponent };